module.exports = __webpack_public_path__ + "media/images/discount_finder-b060e761aa0414dbb97e45d501c07c9f.jpeg";